import { BadgeCheck, FileCheck2, Flame, Leaf, ScrollText, ShieldCheck } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";

const CERTS = [
  { icon: Leaf, name: "Spices Board of India", detail: "CRES Registered", sub: "Official Registered Spice Exporter" },
  { icon: ShieldCheck, name: "FSSAI", detail: "Central Licensed", sub: "Food Safety & Standards Authority of India" },
  { icon: BadgeCheck, name: "ISO 22000:2018", detail: "Certified", sub: "Food Safety Management System" },
  { icon: Flame, name: "HACCP", detail: "Compliant", sub: "Hazard Analysis Critical Control Point" },
  { icon: ScrollText, name: "IEC · DGFT", detail: "Govt. of India", sub: "Importer Exporter Code" },
  { icon: FileCheck2, name: "APEDA", detail: "Registered", sub: "Agricultural & Processed Food Export Authority" },
];

export default function Certifications() {
  return (
    <section id="certifications" data-testid="certifications-section" className="bg-cream py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal className="max-w-2xl">
          <Eyebrow>Quality & Certifications</Eyebrow>
          <h2 className="mt-3 font-serif text-3xl font-semibold leading-tight text-ink sm:text-4xl lg:text-5xl">
            Compliance your customs broker will love
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-smoke sm:text-base">
            Every consignment carries batch-wise Certificates of Analysis from NABL-accredited laboratories.
            Third-party inspection — SGS, Geo-Chem or Intertek — is welcome at buyer request before container stuffing.
          </p>
        </Reveal>
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {CERTS.map((c, i) => (
            <Reveal key={c.name} delay={i * 0.06} className="h-full">
              <div
                data-testid={`cert-card-${c.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group flex h-full items-start gap-5 rounded-2xl border border-stone2 bg-white p-6 transition-all duration-500 hover:-translate-y-1.5 hover:border-gold hover:shadow-[0_20px_50px_-18px_rgba(212,139,22,0.35)]"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-botanical/10 text-botanical transition-colors duration-500 group-hover:bg-botanical group-hover:text-cream">
                  <c.icon size={22} />
                </span>
                <div>
                  <h3 className="font-serif text-lg font-semibold text-ink">{c.name}</h3>
                  <p className="mt-0.5 font-mono text-xs uppercase tracking-[0.14em] text-gold">{c.detail}</p>
                  <p className="mt-1.5 text-sm text-smoke">{c.sub}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
